import { parseAnimation, type AnimationConfig } from '@game-platform/pack-animation';

/** A pack's `animation` as the backend sends it: a whole section, or null when the pack plays the global one. */
export function parseOfferAnimation(raw: unknown): AnimationConfig | null {
  return raw !== null && typeof raw === 'object' && !Array.isArray(raw) ? parseAnimation(raw) : null;
}
